module.exports = require("asn1-ts");